/* Copyright (C) mroads, LLC - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Premsagar Choudhary <premsagar.choudhary@mroads.com>, May 2021
 * @format
 * @flow
 */

import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { Group, Rect, Circle, Transformer, Text as KonvaText } from 'react-konva';
import tranformerConfig from './tranformerConfig';

const Table6Circle = props => {
  const {
    shapeProps,
    isSelected,
    onSelect,
    onChange,
    draggable,
    tableInfoColumn,
    keyName1,
    keyName2,
    keyName3,
  } = props;
  const { x, y, scaleX, scaleY, rotation, stroke, strokeWidth } = shapeProps;
  const shapeRef = useRef();
  const trRef = useRef();

  useEffect(() => {
    if (draggable && isSelected) {
      trRef.current.setNode(shapeRef.current);
      trRef.current.getLayer().batchDraw();
    }
  }, [isSelected]);

  const onDragEnd = e => {
    onChange && onChange({
      ...shapeProps,
      x: e.target.x(),
      y: e.target.y(),
    });
  };

  const onTransformEnd = e => {
    //transformer is changing scale
    const node = shapeRef.current;
    const scaleX = node.scaleX();
    const scaleY = node.scaleY();
    node.scaleX(1);
    node.scaleY(1);
    onChange && onChange({
      ...shapeProps,
      x: node.x(),
      y: node.y(),
      scaleX: scaleX,
      scaleY: scaleY,
      rotation: node.rotation(),
    });
  };

  return (
    <>
      <Group
        onClick={onSelect}
        onTap={onSelect}
        ref={shapeRef}
        x={x}
        y={y}
        scaleX={scaleX}
        scaleY={scaleY}
        rotation={rotation}
        draggable={draggable}
        onDragEnd={onDragEnd}
        onTransformEnd={onTransformEnd}
      >

        <Rect x={0} y={80} stroke={stroke} strokeWidth={strokeWidth} width={10} height={40} />
        <Rect x={46} y={38} rotation={60} stroke={stroke} strokeWidth={strokeWidth} width={10} height={40} />
        <Rect x={76} y={38} rotation={30} stroke={stroke} strokeWidth={strokeWidth} width={40} height={10} />
        <Rect x={110} y={80} stroke={stroke} strokeWidth={strokeWidth} width={10} height={40} />
        <Rect x={70} y={152} rotation={-30} stroke={stroke} strokeWidth={strokeWidth} width={40} height={10} />
        <Rect x={17} y={135} rotation={30} stroke={stroke} strokeWidth={strokeWidth} width={40} height={10} />
        <Circle x={60} y={100} stroke={stroke} strokeWidth={strokeWidth} width={100} height={100} radius={50} />
        {tableInfoColumn && <KonvaText text={shapeProps[tableInfoColumn]} x={18} y={90} fill={stroke} fontSize={35} />}
        {keyName1 && <KonvaText text={shapeProps[keyName1]} x={35} y={65} fill={'white'} fontSize={14} />}
        {keyName2 && <KonvaText text={shapeProps[keyName2]} x={35} y={130} fill={'white'} fontSize={14} />}
        {keyName3 && <KonvaText text={shapeProps[keyName3]} x={95} y={100} fill={'white'} fontSize={12} />}
      </Group>
      {draggable && isSelected && <Transformer ref={trRef} {...tranformerConfig} />}
    </>
  );
};

export default Table6Circle;

Table6Circle.propTypes = {
  shapeProps: PropTypes.object,
  isSelected: PropTypes.bool,
  onSelect: PropTypes.func,
  onChange: PropTypes.func,
  draggable: PropTypes.bool,
  tableInfoColumn: PropTypes.string,
};

Table6Circle.defaultProps = {
  shapeProps: {},
  isSelected: false,
  onSelect: () => { },
  onChange: () => { },
  draggable: true,
};
